import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {parseTeamNamespace} from '../../../helpers/models/namespaceHelpers';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getTeams} from '../../../store/data/teams/teamsSelectors';
import {NamespaceAvatar} from './namespaceAvatar';

/*
 * Props.
 */

interface NamespaceAvatarContainerProps {
  namespace: string;
}

/*
 * Selectors.
 */

function getNamespace(_state: AppState, props: NamespaceAvatarContainerProps) {
  return props.namespace;
}

function makeGetTeam() {
  return createSelector([getNamespace, getTeams], (namespace, teams) => {
    const teamId = parseTeamNamespace(namespace);
    if (!teamId) {
      return undefined;
    }
    return teams[teamId];
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<NamespaceAvatarContainerProps>()(() => ({
  team: makeGetTeam(),
}));

export const NamespaceAvatarContainer = connect(mapStateToProps, null)(NamespaceAvatar);
